<template>
<div class="layout-element" v-if="!element.na || parent.viewNaFields">
    <div v-if="!parent.hideIndicators" class="indicator-column">
        <div class="layout-indicator shadow-pulse" :class="{complete: element.value}"></div>
    </div>
    <div v-if="!parent.hideIcons" class="icon-column">
        <slot name="left">
            <v-icon class="layout-icon" v-if="element.icon" color="grey">{{element.icon}}</v-icon>
        </slot>
    </div>

    <div class="controls-column">
        <div class="control-c2">
            <div v-if="element.na" class="na-overlay">NOT APPLICABLE</div>
            <slot>No Content</slot>
        </div>
        <div class="control-c3">
            <slot name="right"></slot>
        </div>
    </div>
    <!-- handle now resides in the sortable list -->
    <!-- <div class="handle-column">
        <v-menu left offset-y>
            <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="element-handle">more_vert</v-icon>
            </template>
            <v-list>
                <slot name="menu">
                </slot>
                <v-list-item @click="$set(element, 'value', null)">
                    <v-list-item-title>Clear Value</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="!element.na" @click="$set(element, 'na', true)">
                    <v-list-item-title>Not Applicable</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="element.na" @click="$set(element, 'na', null) ">
                    <v-list-item-title>Mark Applicable</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        
    </div> -->

</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>

.layout-element {
    display:flex;
    min-height: 10px;
    transition: background-color 0.5s;
}
.controls-column {
    flex-basis: 200px;
    flex-grow: 1;
    display:flex;
    flex-wrap:wrap;
    max-width:100%;
}
.handle-column {
    flex-basis: 10px;
}

.element-handle {
    margin: 5px -6px 2px -10px;
    opacity: 0;
    transition: opacity .7s ease-in-out
}

.layout-element:hover .element-handle {
    opacity: .9;
}

.icon-column {
    flex-basis: 50px;
}

.control-c2 {
    flex-grow: 1;
    padding: 8px 5px 8px 0;
    flex-basis:240px;
    position: relative;
    max-width:100%
}


.control-c3 {
    flex-basis: 105px;
}

.indicator-column {
    flex-basis:10px;
    padding:2px;
}
.layout-indicator {
    background-color: #fafafa;
    /* background-color: #64B5F6; */
    height:100%;
    width:5px;
    border-radius:3px;  
    margin-left: -0px;
    margin-right:5px;
    transition:background-color .5s ease-in-out;
}
.layout-indicator.complete {
    background-color: #BBDEFB;
}
.section-layout:hover .layout-indicator.complete {
    background-color: #64B5F6;
}
.section-layout:hover .layout-indicator {
    background-color: #bbb;
}

.right-button {
    margin: 23px 0 0 10px;
}

.layout-icon {
    margin-top:27px;
    margin-left: 5px;
}

.na-overlay {
    position: absolute;
    top:0px;left:0px;width:100%;
    font-size:30px;
    opacity:.2;
    transform: rotate(-3deg);
    text-align: center;
    padding:10px;
    color:red;
    font-family: 'Fredericka the Great', cursive;
}

@media (max-width: 500px) {
    .controls-column {
        display:block;
    }
    .icon-column {
            display:none
    }
    .control-c2 {
        padding-right:0px;
    }
    .right-button {
        margin: 10px 0 10px 0
    }

}

</style>




// WEBPACK FOOTER //
// ElementLayout.vue?42db3a86